import { z } from 'zod';
import { sectionKConsistency } from '../oasis-rules/consistency/section-k';
export const baseM1060 = z.object({
    m1060a: z.string().nullable(),
    m1060b: z.string().nullable(),
});
export const baseM1060Refined = z.object({
    m1060a: z.string().refine((data) => {
        const value = Number(data);
        if (isNaN(value) || value < 50 || value > 80) {
            return false;
        }
        return true;
    }, {
        message: 'Please enter a value between 50 and 80',
        path: [],
    }),
    m1060b: z.string().refine((data) => {
        const value = Number(data);
        if (isNaN(value) || value < 65 || value > 440) {
            return false;
        }
        return true;
    }, {
        message: 'Please enter a value between 65 and 440',
        path: [],
    }),
});
export const processedK0520 = z.preprocess((input, ctx) => {
    sectionKConsistency({ input, ctx, field: 'k0520' });
    return input;
}, z.array(z.string()));
export const SectionK = {
    m1060: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    k0520: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
        fields: {
            a1: {
                version: ['e1'],
                timepoint: ['soc', 'roc'],
            },
            a4: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            a5: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            b1: {
                version: ['e1'],
                timepoint: ['soc', 'roc'],
            },
            b4: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            b5: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            c1: {
                version: ['e1'],
                timepoint: ['soc', 'roc'],
            },
            c4: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            c5: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            d1: {
                version: ['e1'],
                timepoint: ['soc', 'roc'],
            },
            d4: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            d5: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            z1: {
                version: ['e1'],
                timepoint: ['soc', 'roc'],
            },
            z4: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
            z5: {
                version: ['e1'],
                timepoint: ['dsch'],
            },
        },
    },
    m1870: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
};
// K-K0520A1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520A4-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520A5-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520B1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520B4-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520B5-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520C1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520C4-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520C5-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520D1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520D4-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520D5-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520Z1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520Z4-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-K0520Z5-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// K-M1060_HEIGHT_A-format-3090 VALUES OF NUMERIC ITEMS
// Only the values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.  The submitted value must be greater than or equal to the minimum value listed in the table and less than or equal to the maximum value listed in the table, or it must match one of the remaining special values (if any) that are listed in the table.  The length of the submitted value must not exceed the allowed maximum length for the item.  Signed numbers (with a leading plus or minus sign) will not be accepted.
//  values: [{"value":"50","label":"Minimum value"},{"value":"80","label":"Maximum value"},{"value":"-","label":"Not assessed (no information)"}]
// K-M1060_HEIGHT_A-format-3100 FORMATTING OF POSITIVE INTEGER NUMERIC ITEMS
// Only positive integer values and the special values (if any) that are listed in the "Item Values" table of the Detailed Data Specifications Report will be accepted for this item.  Leading zeroes may be included or omitted from the submitted value as long as the resulting length of the string does not exceed the allowed maximum length for the item.  A decimal point and decimal values are not allowed.  A sign will not be accepted.
// The following examples are allowable if the value to be submitted is equal to [1] and the maximum length is equal to 2: [1], [01].  The following values are NOT allowed and will lead to a fatal error:  [1.], [1.0], [01.], [01.0], [1.1], [01.1], [1.01], [+1], [-2], [+1.3], [-4.5].
//  values: [{"value":"50","label":"Minimum value"},{"value":"80","label":"Maximum value"},{"value":"-","label":"Not assessed (no information)"}]
// K-M1060_WEIGHT_B-format-3090 VALUES OF NUMERIC ITEMS
// Only the values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.  The submitted value must be greater than or equal to the minimum value listed in the table and less than or equal to the maximum value listed in the table, or it must match one of the remaining special values (if any) that are listed in the table.  The length of the submitted value must not exceed the allowed maximum length for the item.  Signed numbers (with a leading plus or minus sign) will not be accepted.
//  values: [{"value":"065","label":"Minimum value"},{"value":"440","label":"Maximum value"},{"value":"-","label":"Not assessed (no information)"}]
// K-M1060_WEIGHT_B-format-3100 FORMATTING OF POSITIVE INTEGER NUMERIC ITEMS
// Only positive integer values and the special values (if any) that are listed in the "Item Values" table of the Detailed Data Specifications Report will be accepted for this item.  Leading zeroes may be included or omitted from the submitted value as long as the resulting length of the string does not exceed the allowed maximum length for the item.  A decimal point and decimal values are not allowed.  A sign will not be accepted.
// The following examples are allowable if the value to be submitted is equal to [1] and the maximum length is equal to 2: [1], [01].  The following values are NOT allowed and will lead to a fatal error:  [1.], [1.0], [01.], [01.0], [1.1], [01.1], [1.01], [+1], [-2], [+1.3], [-4.5].
//  values: [{"value":"065","label":"Minimum value"},{"value":"440","label":"Maximum value"},{"value":"-","label":"Not assessed (no information)"}]
// K-M1870_CRNT_FEEDING-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Able to independently feed self."},{"value":"01","label":"Able to feed self independently but requires: (a) meal set-up; OR (b) intermittent assistance or supervision from another person; OR (c) a liquid, pureed or ground meat diet."},{"value":"02","label":"Unable to feed self and must be assisted or supervised throughout the meal/snack."},{"value":"03","label":"Able to take in nutrients orally and receives supplemental nutrients though a nasogastric tube or gastrostomy."},{"value":"04","label":"Unable to take in nutrients orally and is fed nutrients through a nasogastric tube or gastrostomy."},{"value":"05","label":"Unable to take in nutrients orally or by tube feeding."}]
